import { GetBookResponse } from '@eigtech/contacts-types'
import { groupBy } from 'lodash-es'
import { useMemo } from 'react'

export function useGetActiveContacts(book: GetBookResponse | undefined) {
  return useMemo(() => {
    const contacts = book?.contacts ?? []
    const { removed = [], active = [] } = groupBy(contacts, (contact) =>
      contact.metadata.removedOn ? 'removed' : 'active'
    )

    return { removed, active }
  }, [book])
}
